/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { App as AntApp } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import App from "./App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "~/context";
import AntConfigProvider from "~/context/antdProvider";
import refreshTokenMiddleware from "~/middleware/tokenMiddleware";
import { ReactQueryProvider } from "~/provider/QueryProvider";
import ServiceWorkerWrapper from "~/provider/serviceWorker";

import { store } from "~/store";

import "./index.css";
import { GoogleMapsProvider } from "./provider/GoogleMapsProvider";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HashRouter>
      <Provider store={store}>
        <GoogleMapsProvider>
          <ReactQueryProvider>
            <MaterialUIControllerProvider>
              <AntConfigProvider>
                <AntApp>
                  <ServiceWorkerWrapper />
                  <App />
                </AntApp>
              </AntConfigProvider>
            </MaterialUIControllerProvider>
          </ReactQueryProvider>
        </GoogleMapsProvider>
      </Provider>
    </HashRouter>
  </React.StrictMode>
);

refreshTokenMiddleware(store);
